<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mb-2">
        <vs-button
         v-if="$acl.check('admin')"
        type="border"
          color="danger"
          class="float-right ml-2"
          @click="deleteUser"
          icon="delete"
        >{{$t('Delete') | ToUppercase}}</vs-button>
        <vs-button
          color="primary"
          class="float-right ml-2"
          @click="editUser"
          type="border"
          icon="build"
        >{{$t('Edit') | ToUppercase}}</vs-button>
        <vs-button v-if="user.disabled"
          color="success"
          class="float-right ml-2"
          @click="enableUser"
          type="border"
          icon="person"
        >{{$t('Enable') | ToUppercase}}</vs-button>
        <vs-button v-if="!user.disabled"
          color="warning"
          class="float-right ml-2"
          @click="disableUser"
          type="border"
          icon="voice_over_off"
        >{{$t('Disable') | ToUppercase}}</vs-button>
        <vs-button
         v-if="!$acl.check('admin')"
        @click="popupActivo5=true"
          color="warning"
          class="float-right ml-2"
          type="border"
          icon="launch"
        >{{ $t('AddEditRequest') | ToUppercase}}</vs-button>
      </div>
      <div class="vx-col w-full mb-2">
        <vx-card :title="$t('PersonData') |ToUppercase">
          <table class="userDataTable">
            <tr>
              <td class="fontSemibold">{{$t('Fullname') |ToUppercase}}</td>
              <td>{{ user.firstname }} {{ user.lastname }}</td>
            </tr>
            <tr>
              <td class="fontSemibold">{{$t('Username') |ToUppercase}}</td>
              <td>{{ user.username }}</td>
            </tr>
            <!--
            <tr>
              <td class="fontSemibold">{{$t('Password') |ToUppercase}}</td>
              <td>{{ user.password.substring(0,20) + " ..." }}</td>
            </tr>
            -->
          </table>
        </vx-card>
      </div>
    </div>
    <vs-popup :title="$t('DeleteUserAlert') |ToUppercase" :active.sync="showDeleteAlert">
      <vs-row vs-justify="center" class="mt-2">
        <vs-button
          color="primary"
          type="filled"
          class="mx-2"
          @click="showDeleteAlert = false"
        >{{$t('Cancel') |ToUppercase}}</vs-button>
        <vs-button color="danger" type="filled" @click="acceptDeletion">{{$t('Remove') |ToUppercase}}</vs-button>
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  data() {
    return {
      id: 0,
      user: {
        password: ""
      },
      dealership: {},
      selected: "",
      showDeleteAlert: false,
      hasAcceptedDeletion: false
    };
  },
  methods: {
    async loadData() {
      try {
        let response = await this.$store.dispatch(
          "admin/fetchUser",
          this.id
        );
        this.user = response.data;
        console.log(this.user.disabled);
        console.log(response);
      } catch (error) {
        console.log(error.response.data);
        if (
          error.response.data.code == 404 ||
          error.response.data.code == 500
        ) {
          this.$router.push(
            `../pages/error?error=${error.response.data.error}&code=${
              error.response.data.code
            }&button=${this.$t(
              "BackToUsersButton"
            )}&link=/user/all/`
          );
        }
        console.log(error.response.data);
        this.$vs.notify({
          title: this.$t("Error"),
          text: error.response.data.error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          time: 3000
        });
      }
    },
    editUser() {
      this.$router.push(`/user/edit/${this.id}`);
    },
    disableUser(){
      this.$store.dispatch("admin/disableUser", this.id);
      this.$router.push(`/user/all`);
    },
    enableUser(){
      this.$store.dispatch("admin/enableUser", this.id);
      this.$router.push(`/user/all`);
    },
    async acceptDeletion() {
      this.showDeleteAlert = false;
      this.hasAcceptedDeletion = true;
      await this.deleteUser();
    },
    async deleteUser() {
      if (!this.hasAcceptedDeletion) {
        this.showDeleteAlert = true;
        return;
      }

      this.$vs.loading();
      try {
        let result = await this.$store.dispatch(
          "admin/deleteUser",
          this.id
        );
        this.$vs.notify({
          title: this.$t("SuccessfullyRemoved"),
          text: this.$t("UserSuccessfullyRemoved"),
          iconPack: "feather",
          icon: "icon-check-circle",
          color: "success"
        });

        setTimeout(() => {
          this.$router.push(`/user/all`);
        }, 200);
      } catch (error) {
        this.$vs.notify({
          title: this.$t("Error"),
          text: error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async created() {
    this.id = this.$route.params.user_id;
    this.$vs.loading();
    await this.loadData();
    this.$vs.loading.close();
  }
}
</script>
<style>
.fontSemibold {
  font-weight: 600 !important;
}
.userDataTable {
  white-space: nowrap;
}

.userDataTable td:first-child {
  min-width: 160px;
}

.IDImageWrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.userImage {
  max-height: 400px;
}
.userIDImage {
  max-height: 180px;
}
.center {
  justify-content: center;
  display: flex;
  width: 100%;
}

@media (min-width: 768px) {
  .image {
    width: 100%;
    object-fit: contain;
  }
}
.imageWrapper {
  height: 14em;
  overflow: hidden;
  float: left;
}
.image {
  width: 100%;
  object-fit: cover;
}

.success {
  color: black;
  background: rgb(23, 201, 100) !important;
  box-shadow: 0px 15px 40px -10px rgba(23, 201, 100, 0.9);
}
.danger {
  color: black;
  background: rgb(242, 19, 93) !important;
  box-shadow: 0px 15px 40px -10px rgba(242, 19, 93, 0.9);
}
.warning {
  color: black;
  background: rgb(255, 130, 0) !important;
  box-shadow: 0px 15px 40px -10px rgba(255, 130, 0, 0.9);
}
</style>